import { createSlice } from '@reduxjs/toolkit';
import {LoginUserClient} from '../../utility/apiClients/user/loginClient';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const loginUser = createAsyncThunk(
  'login/loginUser',
  async (requestBody, { rejectWithValue }) => {
    try {
      const response = await LoginUserClient(requestBody);
      if (response.error) {
        return rejectWithValue(response.error);
      }
      return response; // full API payload
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const LoginSlice = createSlice({
  name: 'login',
  initialState: {
    userData: { custEmail: "", isRememberMe: false, isLoggedIn: false },
    userDetails: { cusToken: null, firstName: "", lastName: "", is_IB: "", Customers_IB_Statuses: "", zipCodes: "" },
    customerInfo: null,
    invoiceCustomerInfo: null,
    loading: false,
    error: null,
    allCustomers: null,
    customerSummaryApiCalled: false,
    allCustomersApiCalled: false,
    selectedCustomer: null
  },
  reducers: {
    setLogin: (state, action) => {
      state.userData = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setCustomerInfo: (state, action) => {
      state.customerInfo = !Array.isArray(action.payload)?[action.payload]:action.payload;
    },
    setCustomerSummaryApiCalled: (state, action) => {
      state.customerSummaryApiCalled = action.payload;
    },
    setAllCustomers: (state, action) => {
      state.allCustomers = action.payload;
    },
    setAllCustomersApiCalled: (state, action) => {
      state.allCustomersApiCalled = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setInvoiceCustomerInfo: (state, action) => {
      state.invoiceCustomerInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        const response = action.payload;

        const customerNums = [];
        const zipCodes = [];
        const Customers_IB_Statuses = [];

        response?.data?.Customers?.forEach(c => customerNums.push(c.CustomerNumber));
        response?.data?.Customers?.forEach(c => zipCodes.push(c.ServiceAddresses?.[0]?.postalCode));
        response?.data?.Customers?.forEach(c => Customers_IB_Statuses.push({[c.CustomerNumber] : `${c.IBStatus === "ACTIVE" ? true : false}`}));

      // map API response into store
        state.userDetails = {
          cusToken: response.data?.LoginInfo?.custoken,
          firstName: response.data?.LoginInfo?.LoginFirstName,
          lastName: response.data?.LoginInfo?.LoginLastName,
          Customers_IB_Statuses: JSON.stringify(Customers_IB_Statuses),
          zipCodes: JSON.stringify(zipCodes)
        };

        state.customerInfo = response.data?.Customers;
        state.allCustomers = response.data?.Customers;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Login failed';
      });
  }
});

export const { setLogin, setCustomerInfo, setAllCustomers, setUserDetails, setCustomerSummaryApiCalled, setAllCustomersApiCalled, setSelectedCustomer, setInvoiceCustomerInfo } = LoginSlice.actions;
export default LoginSlice.reducer;